export const UPDATE_NEW_LISTINGS = "UPDATE_NEW_LISTINGS";